import { BrowserTracing } from '@sentry/tracing'
import * as Sentry from '@sentry/vue'

// Local runs (`vite dev`, and the production build the local E2E stack serves on
// localhost:3108) must not report to the real Sentry project. The hostname check
// covers the E2E build, which is a plain `vite build` with no local flag.
const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]'])

function isLocalRun() {
  return import.meta.env.DEV || LOCAL_HOSTNAMES.has(window.location.hostname)
}

export default {
  install: (app, { router }) => {
    if (isLocalRun()) return

    Sentry.init({
      app,
      dsn: 'https://62fa162a45bc49d38aaf760ce7327524@o417911.ingest.sentry.io/4504828867903488',
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracingOrigins: [
            'localhost',
            'verify-wallet.riseworks.io',
            'dev-verify-wallet.riseworks.io',
            'staging-verify-wallet.riseworks.io',
            /^\//,
          ],
        }),
        new Sentry.Replay({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      ignoreErrors: [
        'Not connected to a wallet.',
        'Wallet not authorized',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'TypeError: Load failed',
        'TypeError: Importing a module script failed.',
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      tracesSampleRate: 1.0,
    })
  },
}
